export default "__VITE_ASSET__Do70qnbS__"